import React from "react"

import "moment/locale/es"

import PageBase from "components/Common/PageBase"
import FullSpinner from "components/Common/FullSpinner"

import useOrdersCreate, { tituloDelDia } from "./useOrdersCreate"
import { BREADCRUMB_LIST } from "./static"
import OrderFilters from "./components/OrderFilters"
import ProviderOrderCard from "./components/ProviderOrderCard"

import "./orders-create.css"

const OrdersCreateContainer = () => {
  const { state, events } = useOrdersCreate()

  return (
    <>
      {state.isLoading && <FullSpinner />}

      <PageBase
        titleMeta="Crear Pedidos"
        titleBread="Crear Pedidos"
        itemsBread={BREADCRUMB_LIST}
      >
        <div className="ped-page mt-3">
          <div className="ped-head ped-anim">
            <h1>Realizar pedido del día {tituloDelDia(state.date)}</h1>
            {state.isSaved && <span className="ped-guardado">✓ Guardado</span>}
          </div>

          <OrderFilters
            clients={state.clients}
            clientId={state.clientId}
            dates={state.dates}
            date={state.date}
            addresses={state.addresses}
            addressId={state.addressId}
            address={state.address}
            onChangeClient={events.onChangeClient}
            onChangeDate={events.onChangeDate}
            onChangeAddress={events.onChangeAddress}
          />

          {!state.clientId && !state.isLoading && (
            <div className="ped-empty">
              Selecciona un cliente para ver la disponibilidad del día.
            </div>
          )}

          {state.sinProveedores && (
            <div className="ped-empty">
              No hay disponibilidad de proveedores para la zona de entrega
              seleccionada.
            </div>
          )}

          {state.sinProducto && (
            <div className="ped-empty">No hay disponibilidad de producto.</div>
          )}

          {state.grupos.map(grupo => (
            <ProviderOrderCard
              key={`${grupo.rows[0].provider?.id}-${grupo.rows[0].farm_id}`}
              grupo={grupo}
              regionId={state.address?.region_id}
              date={state.date}
              isSaving={state.isSaving}
              editingItem={state.editingItem}
              onCreateOrder={events.onCreateOrder}
              onUpdateItem={events.onUpdateItem}
              onDeleteItem={events.onDeleteItem}
              onStartEdit={events.onStartEdit}
              onCancelEdit={events.onCancelEdit}
            />
          ))}
        </div>
      </PageBase>
    </>
  )
}

export default OrdersCreateContainer
